import { motion } from "framer-motion";

const rubros = [
  {
    nombre: "Aberturas y carpintería",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/c416d5a0-1600-49b3-b530-2b1d32a61763.png",
  },
  {
    nombre: "Piscinas",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/892b433a-8e7c-4d12-9e10-d26d1e9d0510.png",
  },
  {
    nombre: "Climatización",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/6ea4f27c-5bf8-45e3-b025-5b658f1f000e.png",
  },
  {
    nombre: "Reformas y remodelaciones",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/e3a4dd65-2099-416f-bdc7-344c8981718f.png",
  },
  {
    nombre: "Plomería y gas",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/2256e802-25b6-4d81-8b10-eebc66fa2d16.png",
  },
  {
    nombre: "Electricidad",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/ae3a039a-1b90-4d9d-aab9-ec59eb3b2800.png",
  },
  {
    nombre: "Paisajismo y riego",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/e33411fe-521b-4cf0-b92e-b87cd61323e7.png",
  },
  {
    nombre: "Energía solar",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/947346ab-b7d2-4fe2-90fe-3376b69f7d83.png",
  },
  {
    nombre: "Portones automáticos",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/40b40f3e-1334-460f-86d8-a2ac0befdaff.png",
  },
  {
    nombre: "Impermeabilización y techos",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/3944ca25-652c-4be4-ae9c-2dcc67b618f4.png",
  },
  {
    nombre: "Talleres mecánicos",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/6654a8d8-a431-429f-b79d-9f4f8c722a2d.png",
  },
  {
    nombre: "Toldos y cerramientos",
    img: "https://vibe.filesafe.space/1775608735188032431/assets/9303d584-d2c3-4b90-9f0f-6775d5175f0c.png",
  },
];

const rubrosExtra = [
  "Muebles a medida, placares y cocinas",
  "Pisos y colocación",
  "Cámaras y alarmas",
  "Ferreterías",
  "Cerrajería 24 horas",
  "Control de plagas",
  "Pintura de obra",
  "Destapaciones",
  "Bombas y servicio técnico",
  "Limpieza de tapizados y de fin de obra",
  "Mudanzas",
  "Tratamiento de agua",
  "Sanitarios y grifería",
];

export const RubrosSection = () => {
  return (
    <section className="bg-[#08080A] py-24 lg:py-[160px] relative">
      <div className="container mx-auto px-6 max-w-[1200px]">
        <div className="max-w-3xl mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <h2 className="text-[32px] md:text-[44px] lg:text-[56px] font-medium text-[#FAFAFA] tracking-[-0.03em] leading-[1.05] mb-6">
              Trabajamos con estos rubros y más...
            </h2>
          </motion.div>
        </div>

        {/* Capa 1 — grilla visual */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6 mb-20">
          {rubros.map((rubro, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{
                duration: 0.5,
                delay: idx * 0.05,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[4/3] rounded-[12px] overflow-hidden border border-white/5 hover:border-white/20 transition-all duration-300 mb-3">
                <img
                  src={rubro.img}
                  alt={rubro.nombre}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <p className="text-[#FAFAFA] text-[14px] md:text-[15px] font-medium leading-tight">
                {rubro.nombre}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Capa 2 — listado completo */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="border-t border-white/5 pt-16"
        >
          <p className="text-[#71717A] font-mono text-[13px] tracking-[0.08em] uppercase mb-8">
            ● Y MUCHOS MÁS
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-4 mb-12">
            {rubrosExtra.map((rubro, idx) => (
              <div
                key={idx}
                className="flex items-center gap-3 text-[#A1A1AA] text-[15px] leading-[1.6]"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-[#7C3AED]/60 shrink-0" />
                {rubro}
              </div>
            ))}
          </div>
          <p className="text-[#A1A1AA] text-[16px] leading-[1.6] mb-2">
            ¿No ves tu rubro? Si vivís de mandar presupuestos, probablemente
            trabajamos igual.
          </p>
          <a
            href="mailto:info@crecelocal.com"
            className="text-[#A78BFA] font-mono text-[13px] tracking-[0.08em] uppercase hover:text-[#C4B5FD] transition-colors"
          >
            Escribinos →
          </a>
        </motion.div>
      </div>
    </section>
  );
};
